export function fileDownload(file: string | ArrayBuffer, name?: string) {
  const blob = new Blob([file]);
  const fileNameDefault = `${Date.now()}.csv`;
  const fileName = name || fileNameDefault;
  const anchorEl = document.createElement('a');
  document.body.appendChild(anchorEl);

  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const url = window.URL.createObjectURL(blob);
    anchorEl.href = url;
    anchorEl.download = fileName;
    anchorEl.click();
    window.URL.revokeObjectURL(url);
  }

  document.body.removeChild(anchorEl);
}
